import { stringIncludesInsensitiveAccents } from '../../utils/normalizeForSearch';

/**
 * Add IDs to exportUrls items using url as unique identifier
 * @param {Array<ApiDashboardExportUrls>} items - The items to add IDs to
 * @returns {Array<DashboardExportUrlsWithId>} Items with IDs
 */
export const addIdsToExportUrls = (items) => items.map((item, index) => ({
  ...item,
  id: item.url || `export-${index}`,
}));

/**
 * Filter exportUrls by search value (searches in lib only)
 * @param {Array<DashboardExportUrlsWithId>} items - The items to filter
 * @param {string} searchValue - The search value
 * @returns {Array<DashboardExportUrlsWithId>} Filtered items
 */
export const filterExportUrlsBySearch = (items, searchValue) => {
  if (!searchValue) return items;

  return items.filter((item) => stringIncludesInsensitiveAccents(item.lib, searchValue));
};
